import styled from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';

export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 112px;
  cursor: pointer;
  overflow: hidden;
  border-radius: 7px;

  @media (min-width: ${Breakpoints.tablet}px) {
    height: 167px;
  }
`;

export const VideoFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
  pointer-events: none;
`;

export const VideoContent = styled.div`
  position: relative;
  flex: 1 1 0;
  min-height: 0;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding-top: 20px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 10px max(60px, calc((100% - 1280px) / 2)) 20px;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    max-height: calc(100vh - 140px);
  }
`;

export const ModalVideoFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
`;
